{
  "name": "@nsc/smartteams-app",
  "displayName": "SmartTeams App",
  "description": "NSC SmartTeams - Mobile PWA for Field Engineers: ServiceNow work-order workflow and academy",
  "version": "1.0.12",
  "private": true,
  "type": "module",
  "scripts": {
    "build": "adornis-cli project build --production --node-port 7000 --listen-port 3000",
    "test": "adornis-cli project test"
  },
  "dependencies": {
    "@adornis/abac": "^2.0.9",
    "@adornis/base": "^16.1.0",
    "@adornis/baseql": "^19.1.1",
    "@adornis/browser-shim": "^2.0.2",
    "@adornis/chemistry": "^19.0.19",
    "@adornis/config": "^11.2.0",
    "@adornis/file-utils": "^24.0.14",
    "@adornis/filter": "^14.0.15",
    "@adornis/fonts": "^19.0.19",
    "@adornis/functional-lit": "6.2.6",
    "@adornis/mails": "^34.0.15",
    "@adornis/mongodb": "^1.0.5",
    "@adornis/maps": "^21.0.11",
    "@adornis/router": "^8.1.3",
    "@adornis/ssr": "^13.0.28",
    "@adornis/user-forms": "^26.0.14",
    "@adornis/users": "^22.0.8",
    "@adornis/validation": "^13.1.0",
    "@iconify-json/material-symbols": "^1.2.70",
    "@nsc/servicenow": "workspace:*",
    "@nsc/simple-lms": "workspace:*",
    "@nsc/smartteams-shared": "workspace:^",
    "construct-style-sheets-polyfill": "^3.1.0",
    "daisyui": "5.6.0",
    "express": "^5.2.1",
    "lit": "^3.3.3",
    "rxjs": "^7.8.2"
  },
  "devDependencies": {
    "@adornis/cli": "^1.8.2"
  },
  "files": [
    "dist"
  ],
  "license": "ISC"
}
